import type { Immutable } from "immer";
import React from "react";

import type { OfferBannerBlock as OfferBannerBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

const LINE_TYPE_CLASSES: Immutable<Partial<Record<string, string>>> = {
    white: styles.offerBannerBlockBarWhite,
    razzmatazz: styles.offerBannerBlockBarRazzmatazz,
};

export const OfferBannerBlock = (
    props: Immutable<{ value: OfferBannerBlockValue }>,
): React.JSX.Element => {
    return (
        <div className={styles.offerBannerBlock}>
            <div className="l-full-width">
                <div className={styles.offerBannerBlockContent}>
                    <div
                        className="rich-text"
                        dangerouslySetInnerHTML={{
                            __html: props.value.copy ?? "",
                        }}
                    />
                    <div
                        className={concatClassNames([
                            styles.offerBannerBlockBar,
                            props.value.line_type
                                ? LINE_TYPE_CLASSES[props.value.line_type]
                                : null,
                        ])}
                    />
                </div>
            </div>
        </div>
    );
};
